import { type ComponentPropsWithoutRef, forwardRef } from "react";

import { twMerge } from "tailwind-merge";

export const Spinner = forwardRef<
  HTMLSpanElement,
  ComponentPropsWithoutRef<"span">
>(({ className, ...props }, ref) => {
  return (
    <span
      ref={ref}
      className={twMerge(
        "spinner-border aspect-square text-[inherit] w-4 h-4 border-2",
        className,
      )}
      role="status"
      aria-hidden="true"
      {...props}
    />
  );
});
